import { Link } from 'react-router-dom';
import { SELLER } from './sellerInfo';

/**
 * Письменная информация о порядке и сроках возврата (ЗоЗПП ст. 26.1).
 * Страница предназначена для печати / сохранения в PDF покупателем и выдачи при передаче товара.
 */
export default function ReturnMemo() {
  const s = SELLER;

  return (
    <div className="container page return-memo" style={{ textAlign: 'left' }}>
      <div className="return-memo__toolbar no-print">
        <button type="button" className="return-memo__print" onClick={() => window.print()}>
          Распечатать / сохранить PDF
        </button>
        <Link to="/delivery">Доставка и возврат</Link>
      </div>

      <h1>Памятка о порядке и сроках возврата товара</h1>
      <p>
        Настоящая памятка предоставляется покупателю интернет‑магазина {s.brand} в соответствии со
        ст. 26.1 Закона РФ «О защите прав потребителей».
      </p>

      <p>
        <strong>Продавец:</strong> {s.name}, ИНН {s.inn}, ОГРНИП {s.ogrnip}. Адрес: {s.address}.
        Телефон: {s.phoneDisplay}. E‑mail: {s.email}. Режим работы: {s.hours}.
      </p>

      <section>
        <h2>1. Отказ до передачи товара</h2>
        <p>Вы вправе отказаться от товара в любое время до его передачи.</p>
      </section>

      <section>
        <h2>2. Отказ после передачи (товар надлежащего качества)</h2>
        <ol>
          <li>
            Вы вправе отказаться от товара надлежащего качества в течение <strong>7 дней</strong> с
            момента передачи товара.
          </li>
          <li>
            Если при передаче товара вам не была предоставлена письменная информация о порядке и
            сроках возврата, срок отказа составляет <strong>3 месяца</strong> с момента передачи
            товара.
          </li>
          <li>
            Возврат возможен при сохранении товарного вида, потребительских свойств товара, а также
            документа, подтверждающего факт и условия покупки (либо иных доказательств покупки у
            Продавца).
          </li>
          <li>
            Товар надлежащего качества с индивидуально‑определёнными свойствами, если указанный товар
            может быть использован исключительно приобретающим его потребителем, возврату не
            подлежит.
          </li>
          <li>
            Расходы на обратную доставку товара надлежащего качества, как правило, несёт покупатель,
            если иное не предусмотрено законом.
          </li>
        </ol>
      </section>

      <section>
        <h2>3. Товар ненадлежащего качества</h2>
        <p>
          При обнаружении недостатков вы вправе предъявить требования, предусмотренные Законом РФ «О
          защите прав потребителей» (в том числе ремонт, замена, уменьшение цены, возврат денег).
          Продавец вправе провести проверку качества и/или экспертизу.
        </p>
      </section>

      <section>
        <h2>4. Как оформить возврат</h2>
        <ol>
          <li>
            Направьте обращение на e‑mail <strong>{s.email}</strong> с темой «Возврат» либо
            позвоните по телефону <strong>{s.phoneDisplay}</strong>.
          </li>
          <li>
            Укажите: ФИО, телефон, номер заказа, наименование товара, причину возврата, способ
            возврата денежных средств.
          </li>
          <li>Дождитесь подтверждения и инструкций по передаче товара Продавцу.</li>
          <li>
            Денежные средства возвращаются тем же способом, которым была произведена оплата (если не
            согласовано иное), в сроки, установленные законом.
          </li>
        </ol>
      </section>

      <section>
        <h2>5. Дополнительно</h2>
        <p>
          Полные условия договора — в <Link to="/oferta">публичной оферте</Link>. Политика обработки
          персональных данных — <Link to="/privacy">здесь</Link>.
        </p>
        <p>
          Дата памятки: {s.updatedAt}. Актуальная версия всегда доступна по адресу {s.site}
          /return-memo
        </p>
      </section>

      <style>{`
        .return-memo__toolbar {
          display: flex;
          gap: 16px;
          align-items: center;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }
        .return-memo__print {
          border: 1px solid currentColor;
          background: transparent;
          padding: 8px 14px;
          cursor: pointer;
          font: inherit;
        }
        @media print {
          .no-print { display: none !important; }
          .site-footer, .site-header, .cookie-banner, .floating-contacts { display: none !important; }
          .return-memo { max-width: 100%; }
          a { color: inherit; text-decoration: none; }
        }
      `}</style>
    </div>
  );
}
